__turbopack_context__.v({
  "container": "DKMemberShipDisplay-module-scss-module__cnqq7W__container",
  "count": "DKMemberShipDisplay-module-scss-module__cnqq7W__count",
  "description": "DKMemberShipDisplay-module-scss-module__cnqq7W__description",
  "loading": "DKMemberShipDisplay-module-scss-module__cnqq7W__loading",
  "number": "DKMemberShipDisplay-module-scss-module__cnqq7W__number",
  "shimmer": "DKMemberShipDisplay-module-scss-module__cnqq7W__shimmer",
});
